import { Tooltip } from '@mantine/core';
import { KeyboardShortcut } from '@repo/common/components/KeyboardShortcut/KeyboardShortcut';
import { IconButton, Text } from '@repo/foundations';
import { memo } from 'react';
import { openSpotlight } from '../../Spotlight';

export const SearchButton = memo(() => {
	const handleSearchClick = () => {
		openSpotlight({ type: 'search' });
	};

	return (
		<Tooltip
			label={
				<KeyboardShortcut keys={['/']}>
					<Text size="xs">Search workspace</Text>
				</KeyboardShortcut>
			}
			position="top"
		>
			<IconButton
				variant="default"
				size="md"
				onClick={handleSearchClick}
				iconName="search"
			/>
		</Tooltip>
	);
});
